// extracted by mini-css-extract-plugin
export var emptyState = "_6s-d";
export var statCard = "_6s-c";
export var table = "_6s-0";
export var tableCell = "_6s-4";
export var tableCellClickable = "_6s-5 _6s-4";
export var tableCellDefault = "_6s-6 _6s-4";
export var tableCellEmpty = "_6s-8";
export var tableCellWithValue = "_6s-7";
export var tableContainer = "_6s-e";
export var tableHeaderWeight = "_6s-1";
export var tableHeaderZone = "_6s-2";
export var tableRowHeader = "_6s-3";
export var viewModeButton = "_6s-9";
export var viewModeButtonActive = "_6s-a _6s-9";
export var viewModeButtonInactive = "_6s-b _6s-9";